module.exports = __webpack_public_path__ + "img/thumbnail_NorthIslandBrownKiwi_f_leucistic.79770c1a.png";